import moment from 'moment'

export const LUX_PLUS_MONTH_TAKEOVER_START_DATE = moment('2025-08-01T13:30:00+1000')
export const LUX_PLUS_MONTH_TAKEOVER_END_DATE = moment('2025-08-31T23:59:00+1000')

export const LUX_PLUS_MONTH_TAKEOVER_ID = 'lux-plus-month'
export const LUX_PLUS_MONTH_CAMPAIGN_ID = 'LuxPlus+ month'
// export const LUX_PLUS_MONTH_SEARCH_URL = `/search?destinationName=${ANYWHERE_NAME}&destinationId=${ANYWHERE_PLACE_ID}&adults=2&children=none&campaigns=${encodeURIComponent(LUX_PLUS_MONTH_CAMPAIGN_ID)}`
export const LUX_PLUS_MONTH_ALL_OFFERS_URL = '/lux-plus'

export const LUX_PLUS_MONTH_HIGHLIGHT_BLUE = '#8dc0ff'
